export default "__VITE_ASSET__CJTtqIo6__"